import {
  COUNTRY_COOKIE,
  DEFAULT_COUNTRY,
  SHOP_STORE_CODE_COOKIE,
  STORE_CODE_DEFAULT,
} from 'dotcom-core/src/constants';

function getCookie(cookieString: string | null, key: string) {
  if (!cookieString) return null;

  const cookies = cookieString.split(';');

  for (const cookie of cookies) {
    const [cookieKey, cookieValue] = cookie.trim().split('=');
    if (cookieKey === key) {
      return cookieValue;
    }
  }

  return null;
}

function getLocalizationCountryCookie(): string {
  const country = getCookie(document.cookie, COUNTRY_COOKIE) || DEFAULT_COUNTRY;

  return country;
}

function getShopStoreCodeCookie(): string {
  const country =
    getCookie(document.cookie, SHOP_STORE_CODE_COOKIE) || STORE_CODE_DEFAULT;

  return country;
}

function parseCookieConsentGroups(
  cookieString: string | null,
): Record<string, boolean> {
  if (!cookieString) {
    return {
      C0001: true,
      C0002: false,
      C0003: false,
      C0004: false,
    };
  }

  const params = new URLSearchParams(cookieString);
  const groupsStr = params.get('groups');
  if (!groupsStr) {
    return {};
  }

  return groupsStr
    .split(',')
    .reduce((acc: Record<string, boolean>, entry: string) => {
      const [group, value] = entry.split(':');
      acc[group] = value === '1';
      return acc;
    }, {});
}

export {
  getCookie,
  getLocalizationCountryCookie,
  getShopStoreCodeCookie,
  parseCookieConsentGroups,
};
